<template>
  <div class="d-flex">
    <div
      style="height: 100vh; width: 50%;"
      class="d-flex align-center justify-center"
    >
      <div style="width: 400px">
        <h1
          class="text-center font-weight-bold darkBlue--text font-weight-bold mb-7"
        >
          Sign In
        </h1>
        <v-form>
          <v-col class="pb-0">
            <v-text-field
              v-model="username"
              placeholder="Email address"
              hide-details="auto"
              solo
              flat
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="userpswd"
              placeholder="Password"
              hide-details="auto"
              type="password"
              solo
              flat
            ></v-text-field>
          </v-col>

          <v-col class="py-0">
            <v-btn
              :disabled="isButtonDisabled"
              block
              dark
              depressed
              color="#51A7F8"
              class="text-capitalize font-weight-black"
              height="42"
              :loading="isLoading"
              @click="checkuserAuthenticate()"
            >
              Login
            </v-btn>
          </v-col>
          <v-col>
            <v-alert outlined v-if="ishaveerror" type="error">
              {{ this.apistatusmsg }}
            </v-alert>
          </v-col>
        </v-form>
      </div>
    </div>
    <div
      style="height: 100vh; width: 50%; background-image: url('/assets/login-bg.png'); background-size: cover;"
      class="d-flex justify-center align-center"
    >
    <div class="d-flex justify-center flex-column">
      <img src="/assets/logo-xl.svg" height="150">
      <h5 class="text-center darkBlue--text mt-5 text-uppercase" style="line-height: 20px; letter-spacing: 0.6em">Omnichannel Attribution</h5>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "Login",
  data: () => ({
    userinfo: null,
    //username: 'manishdwivedi77@gmail.com',
    //userpswd: 'man@trigma2021',

    username: null,
    userpswd: null,

    userid: null,
    loginusername: null,
    apistatuscode: null,
    apistatusmsg: null,
    ishaveerror: false,
    isButtonDisabled: false,
    isLoading: false
  }),
  methods: {
    checkuserAuthenticate() {
      //this.getuserAuthenticatedata();
      this.checkuserlogin();
    },

    checkuserlogin() {
      this.isLoading = true
      apifactory
        .userAthenticate(this.username, this.userpswd)
        .then((res) => {
           //alert(JSON.stringify(res));

          if (res.status != 200) {
            this.apistatusmsg = res.data.message;
            this.ishaveerror = false;
            this.isLoading = false
          } else {
            this.userinfo = res.data;
            if (res.data.status == 1) {
              this.ishaveerror = false;
              this.apistatuscode = res.data.status;
              this.apistatusmsg = res.data.message;
              this.loginusername = res.data.username;
              this.userid = res.data.id;
              //this.$store.commit("SET_USERNAME", this.loginusername);

              localStorage.setItem("SET_USERNAME", this.loginusername);
              localStorage.setItem("SET_USERID", this.userid);
              this.isLoading = false
              this.goTo("/allapps");
              } else {
              this.apistatusmsg = res.data.message;
              this.ishaveerror = true;
              this.isLoading = false
            }
          }
        })
        .catch(function(error) {
         alert(JSON.stringify(error));
        });
    },
    goTo(url) {
      return this.$router.push(url);
    },
  },
  mounted() {
    window.localStorage.clear();
  },
  watch: {
    username: function() {
      if (this.username.length > 0) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
      //this.selectedBrand = [];

      //alert('hello' + this.selectedCountry);
    },
  },
};
</script>
<style>
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f3f5f8 !important;
  border-radius: 8px !important;
  font-weight: 700;
}
</style>
